import { Stack, Text } from '@vtex/admin-ui'
import { useSkus } from 'hooks'
import { FormattedMessage } from 'react-intl'
import { RuleStack, TextSpinner } from 'ui'
import { RegularEffect, RegularScopeApplyTo } from '../../../../../../typings'
import { SCOPE_OPTIONS } from '../../../../../ItemsView/typing'
import { RegularScopeEmptyView } from './Empty'
import { ItemsView } from './ItemsView'
import { messages } from './messages'
import { AllItemsRule } from './Rules'

type Props = {
  name: string
  config: RegularEffect['scope']
  onAdd: (option?: SCOPE_OPTIONS) => void
  onRemove: (config: RegularEffect['scope']) => void
}

export function RegularScopeView(props: Props) {
  const { name, config, onRemove, onAdd } = props

  const { data: skus, isLoading } = useSkus()

  if (!config)
    return <RegularScopeEmptyView name={name} onAdd={onAdd} labeled={true} />

  const { applyTo } = config

  return (
    <Stack space="$space-4" fluid>
      <Text>
        {applyTo === RegularScopeApplyTo.allItems ? (
          <FormattedMessage
            {...messages.allItemsDescription}
            values={{
              loading: isLoading,
              value: skus?.total,
              spinner: <TextSpinner variant="action1" />,
              b: (content) => <Text variant="action1">{content}</Text>,
            }}
          />
        ) : (
          <FormattedMessage {...messages.description} />
        )}
      </Text>
      {applyTo === RegularScopeApplyTo.allItems ? (
        <RuleStack>
          <AllItemsRule onEdit={onAdd} onRemove={() => onRemove(undefined)} />
        </RuleStack>
      ) : (
        <ItemsView
          name={name}
          config={config}
          onAdd={onAdd}
          onRemove={onRemove}
        />
      )}
    </Stack>
  )
}
